import React, { useState, useContext, useEffect } from "react";
import { useNavigate, Link, useParams } from "react-router-dom";
import { BASE_URL } from "../utils/utils";
import { CartContext } from "../cart/cart";
import karwan from "../images/karvaan.jpg";
import { getAuthorById } from "../utils/utils";
import Navbar from "../navbar/navbar";
import { AuthContext } from "../authmanager/authcontext";
import ProductDescription from "../validators/descriptor";
const AuthorList = ({toggleTheme}) => {
  const {
    cartItems,
    addToCart,
    removeProductByQuantityFromCart,
    finalizeCart,
  } = useContext(CartContext);
  const { isLoggedIn, handleLogout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [authors, setAuthor] = useState([]); // Initialize with null

  const { id } = useParams();
  const accessToken = localStorage.getItem("accessToken");

  useEffect(() => {
    const fetchAuthorData = async () => {
      try {
        setIsLoading(true);
        if (accessToken) {
          const authorData = await getAuthorById(accessToken); // Pass id to getAuthorById
          setAuthor(authorData); // Set author object
          console.log("author", authorData);
        }
      } catch (error) {
        console.error("Failed to fetch author.", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAuthorData();
  }, [accessToken, id]); // Depend on accessToken and id

  const handleRemoveFromCart = (product, quantity) => {
    removeProductByQuantityFromCart(product, quantity);
  };

  return (
    <div>
      {isLoading ? (
        <p>Loading...</p>
      ) : authors.length > 0 ? (
        <div>
          <Navbar toggleTheme={toggleTheme}isAuthor={true} handleLogout={handleLogout} finalizeCart={finalizeCart} />
          <br />
  
          {authors.map((author) => (
            <div key={author.id}>
              <div className="author-container">
                <Link to={`/author/${author.id}`}>
                {author.image && (
                  <img
                  src={BASE_URL + author.image}
                    alt={author.name}
                    className="author-image"
                  />
                )}
                </Link>
                <h2 className="author-name">{author.name}</h2>
                {author.description ? (
                  <ProductDescription
                    description={author.longDescription}
                    className="author-description"
                  />
                ) : (
                  <p className="author-description">
                    No description available for this author.
                  </p>
                )}
              </div>
              <div className="product-grid">
                {author.products && author.products.map((product) => {
                  const selectedProduct = cartItems.find(
                    (item) => item.id === product.id
                  );
                  const quantity = selectedProduct ? selectedProduct.quantity : 0;
  
                  return (
                    <div key={product.id} className="product-item">
                      <h3>{product.name}</h3>
                      {product.image ?(<Link to={`/products/${product.id}`}>
                    <img
                      src={BASE_URL + product.image}
                      alt={product.name}
                      className="product-image"
                    />
                  </Link>):''}
                      <ProductDescription description={product.description} />
                      <p>Price: {product.price}</p>
                      {product.category && (
                        <h3>{product.category.name}</h3>
                      )}
                      {product.pdf?.file && (
                        <a href={`${BASE_URL}${product.pdf.file}`} download>
                        <div className="button-container">
                          <div className="circle">Download PDF</div>
                        </div>
                      </a>
                      )}
                      <div className="button-container">
                        <div className="circle">
                          <span>{`Selected: ${quantity}`}</span>
                        </div>
                        <div className="button-container">
                          <button
                            className="circle"
                            onClick={() => addToCart(product, 1)}
                          >
                            Add to Cart
                          </button>
                          {cartItems.find((item) => item.id === product.id) && (
                            <button
                              className="circle"
                              onClick={() => handleRemoveFromCart(product, 1)}
                            >
                              Remove
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p>No authors found.</p>
      )}
    </div>
  );
  
  
};
export default AuthorList;